export const defaultSpring = { type: 'spring', stiffness: 500, damping: 50 }
